import { useGetCourseQuery } from '@/features/editor/coursesApi'
import type { CourseWithoutBlocks } from '@/types/course'

/**
 * Код курса для ссылок ученикам — только ЖИВОГО курса. У черновика свой код, а деталь по
 * нему посторонним — 404 (черновик неживой), поэтому редактор, читающий черновик
 * (`readId !== id`), кода в курсе не держит (`readEditorCourse`), а здесь живой курс
 * читается отдельно — лишь пока открыта секция ссылок. Не прочитался — ссылок нет.
 */
export const useLiveCourseSlug = (
  course: Pick<CourseWithoutBlocks, 'id' | 'slug' | 'readId'>,
): string | null => {
  const readsDraft = course.readId !== undefined && course.readId !== course.id
  const { data } = useGetCourseQuery(course.id, { skip: !readsDraft })
  if (!readsDraft) return course.slug
  return data?.slug ?? null
}
